<div style="text-align:center">
  <div class="">
    <div class="col-12 text-center p-0 search-v2">
      @if (config && config.searchField != undefined && config.searchField != '') {
        <span class="complex-search-pill"
          >
          <span class="selected-pill-item ng-star-inserted">{{config.searchField.label | translate | async}}
            @if (config.complex_search.length!=undefined && config.complex_search.length>1) {
              <a class="complex-search-pill-close"
                (click)="clearComplexSearch(search)"><i class="fa fa-angle-down"></i></a>
              }
            </span>
          </span>
        }
        <span class="search-icon">
          <i aria-hidden="true" class="fa fa-search"></i>
        </span>
        <input type="text" [ngClass]="showAdvSearch ? 'adv-search-v1': 'adv-search-v2'" #textSearchInput
          class="form-control input-element-main-search input-overlap" value="{{_value}}" autocomplete="off"
          [placeholder]="_placeholder | translate | async" (keydown.enter)="handleKeyEnter($event)"
          (input)="onKey($event)" />
        @if ((showAdvSearch || clearSearch) && isTyping) {
          <span [ngClass]="showAdvSearch?'advsearchspan cross-search':'advsearchspan'"
            (click)="clearSearchItems();">
            <i aria-hidden="true" class="fa fa-times"></i>
          </span>
        }
        @if (getConvoxConfig()) {
          <span class="advsearchspan" (click)="getContactInfo();">
            <i aria-hidden="true" class="fa fa-phone"></i>
          </span>
        }
        @if (face_recognition != undefined && face_recognition && appService !=undefined && appService._face_recognition !=undefined && appService._face_recognition) {
          <span class="advsearchspan" (click)="facerecognition();">
            <i class="fa fa-user"></i>
          </span>
        }
        @if (qrCodeScanner) {
          <span class="advsearchspan" (click)="hasQrCodeScanner();">
            <i aria-hidden="true" class="fa fa-qrcode"></i>
          </span>
        }
        @if (preference.checkCommonConfigEnabled('voice_search')) {
          <span class="advsearchspan_search" (click)="textToSpeech();">
            <i aria-hidden="true" class="fa fa-microphone"></i>
          </span>
        }
        @if (showAdvSearch) {
          <span class="advsearchspan" (click)="openAdvSearch();">
            <i aria-hidden="true" class="fa fa-sliders"></i>
          </span>
        }
        @if (rolePermissionService && rolePermissionService.checkIfEnabled('text_search') && textSearch) {
          <span class="advsearchspan atlasSearch">
            <input (change)="preferenceService.saveCommonConfig('text_search',$event.currentTarget.checked)"
              [checked]="preferenceService.checkCommonConfigEnabled('text_search')" type="checkbox"
              title="Enable Text Search" style="width: 16px;height: 16px;">
          </span>
        }
      </div>
    </div>
    @if (isSearching) {
      <div class="bg-white w-100 mobile-search-container" [ngClass]="position? 'position-absolute': ''"
        style="z-index: 2;">
        <div class="col-12 text-center border-light-grey">
          <h4>Searching ... </h4>
        </div>
      </div>
    }
    @if (apiResponse) {
      <div class="col-12 p-0 search-item-container mobile-search-container" [ngClass]="position? 'position-absolute': ''"
        >
        @if (apiResponse['Response'] == 'False') {
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
              {{apiResponse['Error']}}
            </div>
          </div>
        } @else {
          <div class="text-left" (clickOutside)="closeDropdown()">
            @if (!multiSelect) {
              @if (showSuggestions) {
                <div class="col-12 p-0 search-result-container bg-white">
                  @if (apiResponse.length <= 0) {
                    <div class="no-data-found-for-search">
                    {{cstmErrMsg | translate | async }}</div>
                  }
                  @if (apiResponse.length > 0) {
                    @for (result of apiResponse; track result; let i = $index) {
                      <a [class.active]="markIsActive(i, result)"
                        (click)="handleSelectionClick(result.text, i, result)" href="javascript:void(0)">
                        @if ((!_template || _template == undefined) && capitalise) {
                          <span class="d-block">{{
                          result.text | titlecase}}</span>
                        }
                        @if ((!_template || _template == undefined) && !capitalise) {
                          <span class="d-block">{{
                          result.text}}</span>
                        }
                        @if (_template != undefined && result.templateRef != undefined) {
                          <span>
                            @if (result.templateRef) {
                              <div [innerHtml]='result.templateRef'></div>
                            }
                          </span>
                        }
                      </a>
                    }
                  }
                </div>
              }
              @if (showMore) {
                <div class="u-search-footer show-more-fixed _ss-top-link"><a href="javascript:void(0)"
                (click)="showMoreResult($event)">{{'field.label.show_more' | translate | async}}</a></div>
              }
              @if (fixLabel != '') {
                <div class="u-search-footer _ss-top-link"><a href="javascript:void(0)"
                (click)="labelClick($event)">{{fixLabel.text | translate | async}}</a></div>
              }
              @if (datasource_details != '') {
                <div class="u-search-footer  _ss-bottom-link"><a href="javascript:void(0)"
                (click)="openDetails($event)">{{datasource_details.text | translate | async}}</a></div>
              }
              @if (moreResult && showSuggestions && apiResponse.length > 20) {
                <div class="u-search-footer  _ss-bottom-link"><a href="javascript:void(0)"
                (click)="openAdvSearch()"> More Result</a></div>
              }
            }
            @if (multiSelect && !multiTemplate) {
              @if (showSuggestions) {
                <div class="col-12 p-0 search-result-container bg-white">
                  @if (apiResponse.length <= 0) {
                    <div class="no-data-found-for-search">
                    {{cstmErrMsg | translate | async }}</div>
                  }
                  @for (result of apiResponse; track result; let iRow = $index) {
                    <div
                      class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1'>
                      <input (change)="onItemChecked($event.target.checked, iRow)"
                        [checked]="selectedIndices[iRow]" type='checkbox' class='checkbox'>
                      <div class='u-name'>
                        <label>
                          <span>{{result.patient_name}} @if (result.ivf_primary) {
                            <i class="fa fa-plus-circle text-danger"></i>
                          }</span>
                          <span
                          class='u-preRegistrationNo txt-13 pl-2 pr-1'>{{result.preRegistrationNo}}</span>
                        </label>
                      </div>
                      <span class='u-phone txt-13 pr-2'>{{result.telecom}}</span>
                      <span class='u-uhid txt-13 pl-2'>{{result.uhId}}</span>
                      <span class='u-age txt-13 pl-2'>{{result.patient_age}}</span>
                      <span class='u-gender txt-13'>{{result.patient_gender}}</span>
                      <br>@if (result && result.address && result.address.pincode) {
                        <span class='u-age txt-13'
                        >PIN-{{result.address.pincode}}</span>
                      }
                      <span class='u-uhid txt-13'>{{result.ivf_no}}</span>
                    </div>
                  }
                </div>
              }
              <div class="checbox-wrapper mb-1">
                <div class="u-search-footer"><a href="javascript:void(0)" (click)="getResult($event)">Submit</a>
              </div>
              @if (datasource_details != '') {
                <div class="u-search-footer  _ss-bottom-link"><a href="javascript:void(0)"
                (click)="openDetails($event)">{{datasource_details.text}}</a></div>
              }
              <!-- <button type="button" (click)="getResult($event)" class="primary-btn">
              Submit
            </button> -->
          </div>
        }
        @if (multiSelect && multiTemplate) {
          @if (showSuggestions) {
            <div class="col-12 p-0 search-result-container bg-white">
              @if (apiResponse.length <= 0) {
                <div class="no-data-found-for-search">
                {{cstmErrMsg | translate | async }}</div>
              }
              @for (result of apiResponse; track result; let iRow = $index) {
                <div
                  class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1 d-flex'>
                  <input (change)="onItemChecked($event.target.checked, iRow)"
                    [checked]="result.checked" type='checkbox' class='checkbox'>
                  @if (result.templateRef) {
                    <div [innerHtml]='result.templateRef'></div>
                  }
                </div>
              }
            </div>
          }
           @if (showMore) {
                <div class="u-search-footer show-more-fixed _ss-top-link"><a href="javascript:void(0)"
                (click)="showMoreResult($event)">{{'field.label.show_more' | translate | async}}</a></div>
            }
        }
      </div>
    }
  </div>
}
@if (config && config.setSearchPopup) {
  <div class="complex-search-container">
    <div class="complex-search-body">
      @for (search of config.complex_search; track search) {
        <button type="button" class="p-dropdown-item"
          (click)="onSearchClicked(search)">
          {{search.label | translate | async}}
        </button>
      }
    </div>
  </div>
}
</div>